import * as React from 'react';

import { SlateElement } from 'platejs/static';

import { cn } from '@/lib/utils';

export function AudioElementStatic(props) {
  return (
    <SlateElement {...props} className="mb-1">
      <figure className="group relative cursor-default">
        <div className={cn('h-16 rounded-sm')}>
          <audio className="size-full" src={props.element.url} controls />
        </div>
      </figure>
      {props.children}
    </SlateElement>
  );
}
